import { FormattedMessage } from 'react-intl';
import ExpanderPanel from '@rio-cloud/rio-uikit/ExpanderPanel';

import VariableCard from '../VariableCard/VariableCard';

interface RuntimeStatsBarProps {
    now: Date;
}

const RuntimeStatsBar = ({ now }: RuntimeStatsBarProps) => {
    const title = (
        <span className="display-flex align-items-center gap-5">
            <span className="rioglyph rioglyph-time text-size-14" />
            <span>
                <FormattedMessage id="intl-msg:runtimeStats.title" />{' '}
                <span className="text-color-gray font-family-mono text-size-11">(runtime.&lt;var&gt;)</span>
            </span>
        </span>
    );

    return (
        <div className="margin-bottom-15">
            <ExpanderPanel title={title} open={false} bsStyle="blank" className="margin-bottom-0">
                <div
                    className="display-grid gap-10"
                    style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))' }}
                >
                    <VariableCard name="timestamp" value={Math.floor(now.getTime() / 1000)} />
                </div>
            </ExpanderPanel>
        </div>
    );
};

export default RuntimeStatsBar;
